import React, { useEffect } from 'react';
import { GetPatientFileArchiveTypeList } from '../Adapters/GetPatientFileArchiveTypeList';
import { useAtom } from 'jotai';
import { fileArchiveTypeAtom } from '../Shared/file.archive.type';

export default function useGetFileTypeArchive() {
  const [, setFileArchiveType] = useAtom(
    fileArchiveTypeAtom
  );

  useEffect(() => {
    GetPatientFileArchiveTypeList(setFileArchiveType);
  }, []);
}
